import { OutdoorLampIcon } from './OutdoorLampIcon';

/**
 * author: Borre Haugen
 * id 09F61849-C1AA-4755-B49E-75DB800B5273
 * name outdoor-lamp
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/outdoor-lamp.svg
 * tags
 * - Home Automation 
 */
export const OutdoorLightIcon = OutdoorLampIcon;
export default OutdoorLightIcon